/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// This is to allow onClick for <span>
import { IStatusCount } from '..';
import ResponsiveTable from '../../../../shared/components/ResponsiveTable';
import { SortedColumn } from '../../../../shared/components/ResponsiveTable/models';
import styles from '../productDetailsReport.module.scss';

interface DealProductsTableProps {
  data: IStatusCount[];
  type: string;
  total: number;
  scrollToTable: (value: string) => void;
}

const getColumns = (
  type: string,
  total: number,
  scrollToTable: (value: string) => void,
) =>
  [
    {
      name: 'label',
      title: `${type.charAt(0).toUpperCase() + type.slice(1)} Status`,
      cell: (cntx) => (
        <span
          className={`badge ${styles['badge-grey']} fw-normal label`}
          data-testid="data-label"
        >
          {cntx.row.original.label}
        </span>
      ),
      width: 5,
    },
    {
      name: 'value',
      title: 'Total',
      cell: (cntx) => (
        <span
          className="label gray-link"
          // data-testid="data-value"
          onClick={() => {
            scrollToTable(cntx.row.original.label);
          }}
          style={{ cursor: 'pointer' }}
        >
          {cntx.row.original.value.toLocaleString('en-US')}
        </span>
      ),

      width: 5,
    },
    {
      name: 'progess',
      title: 'Total Percent',
      cell: (cntx) => {
        const percentage = Math.round(
          (total === 0 ? 0 : cntx.row.original.value / total) * 100,
        );

        return (
          <div className="pe-3 d-flex justify-content-between align-items-center">
            <div className={`${styles.outer}`}>
              <div
                style={{ width: `${percentage}%` }}
                className={styles.inner}
              />
            </div>
            <div
              className="label text-end"
              style={{ width: 40 }}
              data-testid="data-percent"
            >
              {percentage}%
            </div>
          </div>
        );
      },
      width: 10,
    },
  ] as SortedColumn[];

export default function BreakdownTable({
  data,
  type,
  total,
  scrollToTable,
}: DealProductsTableProps) {
  return (
    <>
      <div className="d-none d-md-block">
        <ResponsiveTable
          data={data}
          columns={getColumns(type, total, scrollToTable)}
        />
      </div>
      <div className="d-md-none d-block">
        <table>
          <thead>
            <tr>
              <th>Total Percent</th>
              <th style={{ width: '80px' }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item: any) => {
              const percentage = Math.round(
                (total === 0 ? 0 : item.value / total) * 100,
              );

              return (
                <tr>
                  <td>
                    <span
                      className={`badge ${styles['badge-grey']} fw-normal label`}
                      data-testid="data-label"
                    >
                      {item.label}
                    </span>
                    <div className="pe-3 d-flex justify-content-between align-items-center mt-2">
                      <div className={`${styles.outer}`}>
                        <div
                          style={{ width: `${percentage}%` }}
                          className={styles.inner}
                        />
                      </div>
                      <div
                        className="label text-end"
                        style={{ width: 40 }}
                        data-testid="data-percent"
                      >
                        {percentage}%
                      </div>
                    </div>
                  </td>
                  <td style={{ verticalAlign: 'bottom' }}>
                    <u>
                      <span
                        className="label"
                        data-testid="data-value"
                        onClick={() => {
                          scrollToTable(item.label);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {item.value.toLocaleString('en-US')}
                      </span>
                    </u>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
